import { useAuth } from "@clerk/clerk-react";
import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { Navigate } from "react-router-dom";
import { AllRoutes } from "../config/routes";

const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (!clerkKey) {
    return <Navigate to={AllRoutes.SignIn} replace />;
  }

  return <AuthenticatedRoute>{children}</AuthenticatedRoute>;
};

const AuthenticatedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isSignedIn) {
    return <Navigate to={AllRoutes.SignIn} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
